import { useTranslation } from 'react-i18next'

import Text from '../../../Text'

import * as styles from './EntityPhaseItemTooltip.module.css'

function EntityPhaseItemTooltip({
  additionalInfo,
  className = styles.EntityPhaseItemTooltip,
  getPhaseStatusText,
  name,
  status,
}) {
  const { t } = useTranslation()

  const statusText = getPhaseStatusText(status)

  return (
    <div className={className}>
      <Text className={styles.name}>
        {name} {statusText ? `(${t(statusText)})` : null}
      </Text>
      <Text className={styles.additionalInfo}>{additionalInfo}</Text>
    </div>
  )
}

export default EntityPhaseItemTooltip
